import React, { Component } from 'react';
import { CircularProgress } from 'material-ui/Progress'
import { connect } from 'react-redux'
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, DialogContentText } from "material-ui";
import { Field, reduxForm } from 'redux-form';
import { compose } from 'redux'
import FormTextField from './formTextField';
import { formValueSelector } from 'redux-form'
import green from 'material-ui/colors/green'
import { required, match, strength, notContainEmail, notContainFirstName, notContainLastName } from '../utils/validationRules';
import Messages from "../constants/messages";
import PasswordRequirements from './passwordRequirements'
import withStyles from 'material-ui/styles/withStyles'

const styles = theme => ({
  root: {
    float: 'right',
    marginBottom: 15
  },
  btn: {
    textAlign: 'right'
  },
  buttonProgress: {
    color: green[500],
    position: 'absolute',
    right: '0.3em',
    bottom: '0.3em',
    overflow: 'hidden'
  },
  dialogActions: {
    position: 'relative'
  },
  portalContainer: {
    overflow: "scroll"
  },
  field: {
    marginBottom: 15
  },
  formControl: {
    marginTop: theme.spacing.unit * 2,
  },
  notSelected: {
    backgroundColor: "none", //Overides for deselecting in multiselect menuItems
    '&:focus': {
      background: "none",
    }
  },
  svg: {
    height: '24px',
    width: '24px'
  }
})

// ChangePasswordFormDialog component serves a temporary workaround for known issues in the general-purpose FormDialog component
// Refactor of FormDialog component planned.

class ChangePasswordFormDialog extends Component {

  renderDialog() {
    const {
      classes,
      handleSubmit,
      initialValues,
      initiatePasswordChange,
      invalid,
      isSubmitting,
      open,
      password,
      pristine,
      resetForm,
      showPasswordDialog,
      title,
      userId
    } = this.props
    
    return (
      <Dialog
      id="changePasswordFormDialog"
      open={open}
      onRequestClose={() => {
        showPasswordDialog(false)
        resetForm()
      }}
      fullWidth={true}>
        <div className={`${classes.portalContainer} portalContainer`}>
          <DialogTitle>{title}</DialogTitle>
          <form data-test-id="changePasswordDialog" onSubmit={handleSubmit((formValues) => {
            initiatePasswordChange(userId, formValues).then((action) => {if(!action.error) resetForm()})
          })}>
            <DialogContent>
              <DialogContentText>
                {Messages['uiComponents']['PASSWORD_REQUIREMENTS_LABEL']}
                <PasswordRequirements email={initialValues.email} firstName={initialValues.firstName} lastName={initialValues.lastName} password={password} />
              </DialogContentText>
              <Field
                name="currentPassword"
                component={FormTextField}
                label={Messages['uiComponents']['CURRENT_PASSWORD_LABEL']}
                disabled={isSubmitting}
                type="password"
                validate={[required]} />
              <Field
                name="password"
                component={FormTextField}
                label={Messages['uiComponents']['NEW_PASSWORD_LABEL']}
                disabled={isSubmitting}
                type="password"
                validate={[required, strength, notContainEmail, notContainFirstName, notContainLastName]} />
              <Field
                name="confirmNewPassword"
                component={FormTextField}
                label={Messages['uiComponents']['NEW_PASSWORD_CONFIRMATION']}
                disabled={isSubmitting}
                type="password"
                validate={[required, match]} />
              {/* Hidden email field required for password validation (see Redux-form docs) */}
              <Field
                name="email"
                component="input"
                type="hidden" />
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button
                data-test-id="cancelBtn"
                color="primary"
                disabled={isSubmitting}
                onClick={() => {
                  showPasswordDialog(false)
                  resetForm()  
                }}>
                {Messages['uiComponents']['FORM_DIALOG_CANCEL_BUTTON_LABEL']}
              </Button>
              <Button id="submitBtn" color="primary" disabled={invalid || isSubmitting || pristine} type="submit">
                {Messages['uiComponents']['CHANGE_BUTTON']}
              </Button>
              { isSubmitting && <CircularProgress size={24} className={classes.buttonProgress} classes={{svgIndeterminate: classes.svg}} />}
            </DialogActions>
          </form>
        </div>
      </Dialog >
    )
  }
  
  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        {this.renderDialog()}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  initialValues: state.changePasswordFormDialog.initialValues,
  isSubmitting: state.changePasswordFormDialog.isSubmitting,
  password: formValueSelector('changePasswordFormDialog')(state, 'password')
})

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps
    ),
    reduxForm({
      form: 'changePasswordFormDialog'
    })
  )(ChangePasswordFormDialog)